import React from "react";

const FlipHorizontal = ({ color }) => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="24"
    //   height="24"
    //   viewBox="0 0 24 24"
    //   fill="none"
    // >
    //   <path
    //     d="M6.99 11L3 15L6.99 19V16H14V14H6.99V11ZM21 9L17.01 5V8H10V10H17.01V13L21 9Z"
    //     fill={color}
    //   />
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
    >
      <path
        d="M3.99 6.85714L0 11.4286L3.99 16V12.5714H11V10.2857H3.99V6.85714ZM18 4.57143L14.01 0V3.42857H7V5.71429H14.01V9.14286L18 4.57143Z"
        fill={color}
      />
    </svg>
  );
};

export default FlipHorizontal;
